<template>
    <div class="full-page">
        <!-- 左侧 懒得抽离了-->
        <div class="left-class">
            <!-- 搜索 -->
            <div class="search-class">
                <el-input type="text" style="width:250px" :placeholder="$t('public.please_enter')" v-model="filterText" clearable></el-input>
                <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
            </div>
            <!-- 监测点树 -->
            <div class="tree-class">
                <trees ref="tree" :check-strictly="true" :treedata="treeData" v-bind="$attrs" @changeNode="changeNode"> </trees>
            </div>
            <!-- 表单时间 -->
            <div class="form-class">
                <el-form ref="form" v-model="formTime">
                    <div class="date-class">
                        <el-form-item>
                            <template #label>
                                <div style="width: 85px;white-space: nowrap;">{{ $t('integration.set_start_time') }}</div>
                            </template>
                            <el-date-picker
                                type="datetime"
                                :placeholder="$t('integration.select_date')"
                                v-model="formTime.startTime"
                                value-format="timestamp"
                                style="width: 63%"
                                :clear-icon="''"
                            ></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="date-class">
                        <el-form-item :label="$t('integration.set_end_time')">
                            <el-date-picker
                                type="datetime"
                                :placeholder="$t('integration.select_date')"
                                v-model="formTime.endTime"
                                value-format="timestamp"
                                style="width: 63%"
                                :clear-icon="''"
                            ></el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <!-- 设备列表 -->
            <div class="device-class">
                <!-- 列表 -->
                <div class="list-class">
                    <el-table
                        v-load-more.expand="{
                            func: getMore,
                            target: '.el-table__body-wrapper',
                            delay: 100
                        }"
                        stripe
                        ref="multipleTable"
                        :data="deviceList"
                        style="width: 100%"
                        :show-header="false"
                        :height="tableHeight"
                    >
                        <el-table-column prop="name" show-overflow-tooltip>
                            <template #default="{ row }">
                                <div class="content-class">
                                    <div class="child-class">
                                        <i v-icon:theme="['sensorTypeConvert', row.deviceType]"></i>
                                        <i v-icon:theme="['equiStatusConvert', row.deviceStatus]"></i>
                                        <span>{{ row.carrierDeviceName }}</span>
                                    </div>
                                    <el-checkbox v-model="row.checked" @change="change($event, row)"></el-checkbox>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <div class="content-class" v-for="item in deviceList" :key="item.deviceId">
            <div class="child-class">
              <i v-icon:theme="['sensorTypeConvert', item.deviceType]"></i>
              <i v-icon:theme="['equiStatusConvert', item.deviceStatus]"></i>
              <span>{{ item.deviceName }}</span>
            </div>
            <el-checkbox v-model="item.checked" @change="change($event, item)"></el-checkbox>
          </div> -->
                    <!-- <div v-if="noMoreFlag" class="noMOre-class">
            没有更多了
          </div> -->
                </div>
                <!-- 点击加载更多 -->
                <!-- <el-button class="btn-class" type="default" @click="getMore">{{$t('integration.click_to_load_more')}}</el-button> -->
            </div>
        </div>
        <!-- 右侧 -->
        <div class="right-class">
            <!-- 头部 -->
            <template v-if="choozeList.length > 0">
                <div class="header-class">
                    <span>{{ $t('integration.query_data') }}</span>
                    <el-button type="primary" @click="generateCode">{{ $t('integration.generate_query_code') }}</el-button>
                </div>
                <div class="content-list">
                    <div class="child-r-class" v-for="(item, index) in choozeList" :key="item.deviceId">
                        <div class="child-r-child-class">
                            <span class="name-class" :title="item.carrierName">{{ item.carrierName }}</span>
                            <span class="header-r-class">
                                <template v-if="!item.timeFlag">
                                    <i class="el-icon-edit" @click="editTime(item, index)"></i>
                                    <i class="el-icon-delete" @click="delRow(item, index)"></i>
                                </template>
                                <template v-else>
                                    <i class="iconfont icon-baocun" @click="save(item, index)"></i>
                                    <i class="iconfont icon-fanhui" @click="goBack(item, index)"></i>
                                </template>
                            </span>
                        </div>
                        <div class="child-r-child-class">
                            <span class="header-l-class">
                                <i v-icon:theme="['sensorTypeConvert', item.deviceType]"></i>
                                <i v-icon:theme="['equiStatusConvert', item.deviceStatus]"></i>
                            </span>
                            <span>{{ item.carrierDeviceName }}</span>
                        </div>
                        <div class="time-class">
                            <div class="time-child">
                                {{ $t('integration.startTime') }}
                            </div>
                            <div class="time-content-class">
                                <el-date-picker
                                    v-if="item.timeFlag"
                                    type="datetime"
                                    :placeholder="$t('integration.select_date')"
                                    v-model="item.startTime"
                                    value-format="timestamp"
                                    style="width: 100%"
                                    :clear-icon="''"
                                >
                                </el-date-picker>
                                <span v-else>{{ $timetransition(item.startTime) }}</span>
                            </div>
                        </div>
                        <div class="time-class" style="border-bottom:0">
                            <div class="time-child">
                                {{ $t('integration.endTime') }}
                            </div>
                            <div class="time-content-class">
                                <el-date-picker
                                    v-if="item.timeFlag"
                                    type="datetime"
                                    :placeholder="$t('integration.select_date')"
                                    v-model="item.endTime"
                                    value-format="timestamp"
                                    style="width: 100%"
                                    :clear-icon="''"
                                >
                                </el-date-picker>
                                <span v-else>{{ $timetransition(item.endTime) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div v-else class="noData-calss">
                {{ $t('integration.no_query_data_temporarily') }}
            </div>
        </div>
        <!-- 弹出框 -->
        <div class="mask-class" v-show="isShowDialog">
            <div class="mask-content-class">
                <div class="icon-class">
                    <i class="el-icon-error" @click="closeMask"></i>
                </div>
                <!-- 图片 -->
                <div class="content-classs">
                    <img :src="base64" :alt="$t('integration.qr_code')" srcset="" />
                    <p>{{ $t('integration.query_code_valid_time_c_7_days') }}</p>
                    <el-button style="width:100%;margin-top:15px" type="primary" @click="downImg">{{ $t('integration.download_qr_code') }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { shareTree } from '@/api/modules/public.js'
import { getSensorList, getCodeGenerate } from '@/api/modules/findCode.js'
import { downloadImage } from '@/utils/file/download'
export default {
  name: 'findName',
  data () {
    return {
      tableHeight: '100%',
      filterText: '',
      treeData: [],
      deviceList: [],
      noMoreFlag: false,
      formTime: {
        startTime: new Date().getTime() - 6 * 60 * 60 * 1000,
        endTime: new Date().getTime()
      },
      formQuery: {
        iDisplayStart: 0,
        iDisplayLength: 15,
        sceneId: '',
        carrierId: ''
      },
      checked: true,
      // 右侧
      choozeList: [],
      isShowDialog: false,
      base64: ''
    }
  },
  created () {
    this.getMonitorTree()
  },
  methods: {
    getMonitorTree () {
      shareTree({ idEdit: 0, carrier: true })
        .then(res => {
          this.treeData = res.result.item
          return this.treeData[0].scopeId
        })
        .then(sceneId => {
          this.formQuery.sceneId = sceneId
          this.getList()
        })
    },
    getList () {
      getSensorList(this.formQuery).then(res => {
        this.deviceList = res.result.result
        this.noMoreFlag = this.deviceList.length === res.result.pageInfo.total
      })
    },
    getMore () {
      if (this.noMoreFlag) {
        this.$message.warning($t('integration.no_more'))
        return
      }
      this.formQuery.iDisplayLength += 15
      this.getList()
    },
    searchTree () {
      this.$refs.tree.$refs.tree.filter(this.filterText)
    },
    changeNode (e) {
      this.formQuery.iDisplayStart = 0
      this.formQuery.iDisplayLength = 15
      this.formQuery.carrierId = e.label.carrierId || ''
      this.formQuery.sceneId = e.label.sceneId || e.label.scopeId || ''
      this.getList()
    },
    change (e, info) {
      if (e) {
        this.choozeList = [...this.choozeList, { ...info }]
      } else {
        this.choozeList = this.choozeList.filter(item => item.carrierDeviceId !== info.carrierDeviceId)
      }
      this.choozeList.forEach(item => {
        this.$set(item, 'startTime', this.formTime.startTime)
        this.$set(item, 'endTime', this.formTime.endTime)
      })
    },
    generateCode () {
      const params = this.choozeList.map(item => {
        const { carrierId, carrierDeviceId, startTime, endTime } = item
        return {
          carrierId,
          carrierDeviceId,
          startTime,
          endTime
        }
      })
      getCodeGenerate(params).then(res => {
        console.log(res)
        this.base64 = res.result.qrcode.replace(/[\r\n]/g, '')
        //  = 'data:image/jpeg;base64,' + base64;
        this.isShowDialog = true
      })
    },
    closeMask () {
      this.isShowDialog = false
    },
    downImg () {
      // this.download.downloadFile($t('integration.qr_code'), this.base64);
      downloadImage(this.base64, $t('integration.qr_code'))
    },
    delRow (info, index) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('messageTitle.Yes'), // 确定按钮的文案
        cancelButtonText: this.$t('messageTitle.Cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          // mock假删除
          this.choozeList.splice(index, 1)
          for (const item of this.deviceList) {
            if (item.deviceId === info.deviceId) {
              this.$set(item, 'checked', false)
              break
            }
          }
        })
        .catch(() => {})
    },
    editTime (info, index) {
      this.$set(info, 'timeFlag', !info.timeFlag)
    },
    save (info) {
      this.$set(info, 'isSave', true)
      this.$set(info, 'timeFlag', false)
    },
    goBack (info) {
      if (!info.isSave) {
        this.$set(info, 'startTime', this.formTime.startTime)
        this.$set(info, 'endTime', this.formTime.endTime)
      }
      this.$set(info, 'timeFlag', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.full-page {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.left-class {
    width: 300px;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid #cccccc;

    .search-class {
        padding: 10px;
        height: 50px;
        box-sizing: border-box;
        border-bottom: 1px solid #cccccc;
        display: flex;
    }

    .tree-class {
        height: 400px;
        overflow: auto;
        box-sizing: border-box;
        border-bottom: 1px solid #cccccc;
    }

    .form-class {
        ::v-deep .el-form-item--mini.el-form-item {
            margin-bottom: 5px !important;
        }
    }

    .date-class {
        padding: 5px;
        padding-left: 15px;
        padding-bottom: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #cccccc;
    }

    .device-class {
        height: calc(100% - 532px);
    }

    .list-class {
        height: 100%;
        overflow-y: auto;
        padding: 10px;
        box-sizing: border-box;
        // border-bottom: 1px solid #cccccc;
    }

    .content-class {
        height: 30px;
        width: 100%;
        border-radius: 2px;
        display: flex;
        padding: 0 4px 0 4px;
        margin-bottom: 2px;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #cccccc;
    }

    .child-class {
        flex: 1;

        i,
        span {
            margin-right: 5px;
        }
    }

    .btn-class {
        position: absolute;
        left: 2px;
        right: 2px;
        bottom: -2px;
    }

    .noMOre-class {
        text-align: center;
        color: #cccccc;
    }
}

.right-class {
    flex: 1;
    height: 100%;
    box-sizing: border-box;

    .header-class {
        height: 50px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #cccccc;
    }

    .content-list {
        padding: 15px;
        display: flex;
        flex-wrap: wrap;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .child-r-class {
        height: 120px;
        width: 300px;
        margin-right: 15px;
        margin-bottom: 15px;
        border-radius: 2px;
        border: 1px solid #cccccc;
        box-sizing: border-box;
    }

    .child-r-child-class {
        height: 30px;
        line-height: 30px;
        text-align: center;
        position: relative;
        border-bottom: 1px solid #cccccc;
        box-sizing: border-box;
    }

    .name-class {
        display: inline-block;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .header-l-class {
        position: absolute;
        left: 10px;

        i {
            margin-right: 5px;
            cursor: pointer;
        }
    }

    .header-r-class {
        position: absolute;
        right: 10px;

        i {
            margin-left: 5px;
            cursor: pointer;
        }
    }

    .time-class {
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        box-sizing: border-box;
    }

    .time-child {
        height: 100%;
        line-height: 30px;
        padding-left: 10px;
        padding-right: 10px;
        background-color: var(--primary-color);
        color: #ffffff;
    }

    .time-content-class {
        flex: 1;
        text-align: center;
    }

    .noData-calss {
        height: 100%;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #cccccc;
    }
}

.mask-class {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 999;
}

.mask-content-class {
    position: fixed;
    width: 400px;
    height: 400px;
    top: 50%;
    left: 50%;
    border-radius: 2px;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    box-sizing: border-box;
    z-index: 1000;

    .icon-class {
        text-align: right;
        margin-top: 5px;
        margin-right: 5px;
        cursor: pointer;
    }

    .el-icon-error {
        font-size: 20px;
    }

    .content-classs {
        padding-left: 50px;
        padding-right: 50px;
    }

    p {
        text-align: center;
    }
}
</style>
